import * as stylex from '@stylexjs/stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  btn: {
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighRegular,
    display: 'flex',
    padding: '8px 20px 8px 12px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: anatomy['space-8'],
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  children: {
    color: colors.accentText,
  },
});
